import { Schema } from './schema.js';
export class APIResult {
    constructor(outputType, outputValue) {
        this.outputType = outputType;
        this.outputValue = outputValue;
    }
    static boolean(value) {
        return new APIResult(Schema.boolean_type.getTypeReference(), value);
    }
    static string(value) {
        return new APIResult(Schema.string_type.getTypeReference(), value);
    }
    static mlString(value) {
        return new APIResult(Schema.ml_string_type.getTypeReference(), value);
    }
    static number(value) {
        return new APIResult(Schema.number_type.getTypeReference(), value);
    }
    static custom(outputType, value) {
        return new APIResult(outputType, value);
    }
}
export class PluginBase {
    registerPrototypes() {
        return new Map();
    }
    registerStatics() {
        return new Map();
    }
    setup(schema) {
    }
}
//# sourceMappingURL=plugin.js.map